// Partidas habituales de reforma integral en España.
// Precios orientativos €/m² sobre la superficie total de la vivienda.
// Estándar = media de mercado España 2026.
// Optimizado = ajustado pero realista (sin perder calidad básica).
// "ajustable" = el usuario puede bajar fácilmente sin avisos críticos (Electricidad, Tabiquería, Azulejo).

export const PARTIDAS_DEFAULT = [
  { id: 'demolicion', name: 'Demolición y retirada', icon: 'Hammer', estandar: 25, optimizado: 18, ajustable: false, descripcion: 'Derribo, carga y gestión de escombros.' },
  { id: 'tabiqueria', name: 'Tabiquería (pladur / ladrillo)', icon: 'LayoutPanelLeft', estandar: 65, optimizado: 48, ajustable: true, descripcion: 'Distribución interior con pladur o ladrillo.' },
  { id: 'electricidad', name: 'Electricidad', icon: 'Zap', estandar: 38, optimizado: 28, ajustable: true, descripcion: 'Instalación eléctrica completa con boletín.' },
  { id: 'fontaneria', name: 'Fontanería', icon: 'Droplet', estandar: 32, optimizado: 24, ajustable: false, descripcion: 'Renovación de instalación, sanitarios y desagües.' },
  { id: 'azulejo', name: 'Alicatado / Azulejo', icon: 'Grid3x3', estandar: 55, optimizado: 38, ajustable: true, descripcion: 'Paredes de baño y cocina con cerámica/porcelánico.' },
  { id: 'suelos', name: 'Suelos (cerámico / tarima)', icon: 'Square', estandar: 48, optimizado: 35, ajustable: false, descripcion: 'Pavimento de la vivienda.' },
  { id: 'pintura', name: 'Pintura interior', icon: 'PaintRoller', estandar: 16, optimizado: 12, ajustable: false, descripcion: 'Imprimación y dos manos de pintura plástica.' },
  { id: 'carpinteria', name: 'Carpintería (puertas / armarios)', icon: 'DoorOpen', estandar: 95, optimizado: 65, ajustable: false, descripcion: 'Puertas de paso y armarios empotrados.' },
  { id: 'sanitarios', name: 'Sanitarios y grifería', icon: 'ShowerHead', estandar: 28, optimizado: 20, ajustable: false, descripcion: 'Inodoro, lavabo, ducha/bañera y griferías.' },
  { id: 'yesos', name: 'Yesos y falsos techos', icon: 'Layers', estandar: 22, optimizado: 16, ajustable: false, descripcion: 'Enlucidos, falsos techos y maestreados.' },
];

export const PRECIO_MEDIA = (p) => (p.estandar + p.optimizado) / 2;

// Umbral por debajo del cual mostramos advertencia
export const UMBRAL_BAJO = (p) => p.optimizado * 0.85;

// Reducción global "Versión optimizada" sobre el precio Estándar de las partidas marcadas ajustables.
export const GLOBAL_OPT_PARTIDAS = ['tabiqueria', 'electricidad', 'azulejo'];

export const TIPOS_OBRA = [
  { id: 'integral', label: 'Reforma integral' },
  { id: 'cocina-bano', label: 'Reforma de cocina y baño' },
  { id: 'cocina', label: 'Solo cocina' },
  { id: 'bano', label: 'Solo baño' },
  { id: 'pintura-suelo', label: 'Pintura y suelo' },
  { id: 'otro', label: 'Otro / Personalizado' },
];
